import React, { useMemo } from 'react';
import { InstantSearch } from 'react-instantsearch';
import PropTypes from 'prop-types';

import { getAlgoliaIndexNameGlobal } from '@general/helpers/search.helpers';
import useAlgoliaClient from '@hooks/search/useAlgoliaClient';
import useViewer from '@hooks/useViewer';
import LoadingArea from '@molecules/LoadingArea';

const SearchContainer = ({ index, initialSearchState, insights = true, refresh = false, children, onStateChange }) => {
    const { viewer } = useViewer();
    const { searchClient } = useAlgoliaClient();
    const indexName = useMemo(() => getAlgoliaIndexNameGlobal(index), [index]);
    const insightsParams = useMemo(() => {
        if (!insights || typeof viewer === 'undefined') {
            return;
        }

        if (viewer) {
            window.aa('setUserToken', viewer.recordId.toString());
        }

        return {
            insightsInitParams: {
                useCookie: true,
            },
        };
    }, [insights, viewer]);

    if (!searchClient || typeof viewer === 'undefined') {
        return <LoadingArea />;
    }

    const attrs = {};

    if (onStateChange) {
        attrs.onStateChange = onStateChange;
    }

    return (
        <InstantSearch
            indexName={indexName}
            initialUiState={initialSearchState}
            insights={insightsParams}
            refresh={refresh}
            searchClient={searchClient}
            {...attrs}
        >
            {children}
        </InstantSearch>
    );
};

SearchContainer.propTypes = {
    index: PropTypes.string.isRequired,
    initialSearchState: PropTypes.object,
    insights: PropTypes.bool,
    refresh: PropTypes.bool,
    children: PropTypes.node.isRequired,
    onStateChange: PropTypes.func,
};

export default SearchContainer;
